/**
 * Source: Figma "RM V2 Library (MUI v7.2.0)" — Theme page, `Variables Design Sheet` → `shape/*`.
 * https://www.figma.com/design/kMeScGRhmLq2l22M2ZkmiE/RM-V2-Library--MUI-v7.2.0-?node-id=11207-164308
 *
 * Verified with design (IL - 05/08/2026)
 */
export const RADIUS_BASE = 4;

/**
 * These tokens are used specifically for component overrides.
 */
export const RadiusToken = {
  XS: 4,
  SM: 8,
  MD: 12,
  LG: 16,
  XL: 24,
  MAX: 9999,
};

export const Shape = {
  square: 0,
  subtle: 1,
  soft: 2,
  medium: 3,
  rounded: 4,
  large: 6,
  pill: 9999,
};
